(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-rise-review-deck]').forEach(deck => {
      if (deck.dataset.ready) return;
      deck.dataset.ready = 'true';
      const track = deck.querySelector('.rise-quiet-reviews__track');
      const cards = [...track.querySelectorAll('.rise-quiet-review')];
      const prev = deck.querySelector('[data-review-prev]');
      const next = deck.querySelector('[data-review-next]');
      const count = deck.querySelector('[data-review-count]');
      const mobile = window.matchMedia('(max-width: 749px)');
      let index = 0;
      const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      const sync = () => {
        index = mobile.matches ? Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / Math.max(1, step())))) : 0;
        count.textContent = `${index + 1} / ${cards.length}`;
        prev.disabled = index === 0;
        next.disabled = index === cards.length - 1;
      };
      const go = delta => {
        if (!mobile.matches) return;
        const target = Math.max(0, Math.min(cards.length - 1, index + delta));
        track.scrollTo({left: step() * target, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      prev.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));
      track.addEventListener('scroll', sync, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !mobile.matches) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();go(event.key === 'ArrowRight' ? 1 : -1);}
      });
      mobile.addEventListener('change', () => {track.scrollTo({left: 0, behavior: 'instant'});sync();});
      window.addEventListener('resize', sync, {passive: true});
      sync();
    });
  };
  init();
  if (!window.riseReviewDeckListening) {
    window.riseReviewDeckListening = true;
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
})();
